import { render, staticRenderFns } from "./RecordNewNotification.vue?vue&type=template&id=18392dc1&scoped=true&"
import script from "./RecordNewNotification.vue?vue&type=script&lang=js&"
export * from "./RecordNewNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordNewNotification.vue?vue&type=style&index=0&id=18392dc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18392dc1",
  null
  
)

export default component.exports